























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _ from "lodash";
import { Getter } from "vuex-class";
import ThousandNumberInput from "@/components/forms/inputs/ThousandNumberInput.vue";
import BundleRepository from "@/repositories/socle/BundleRepository";
import moment from "moment";
import Http from "front-component/Http";
import EventBus from "front-component/EventBus";
import {Bundle} from "@/modules/socle/Bundle";
import {BundleLog} from "@/modules/socle/BundleLog";
import {MessageBoxInputData} from "element-ui/types/message-box";
import {User} from "front-component/modules/User";
import {
    SOCLE_APPROVAL_STATUS_APPROVED,
    SOCLE_APPROVAL_STATUS_PENDING,
    SOCLE_APPROVAL_STATUS_RECOMMENDED
} from "@/Constants";
import {Budget} from "@/repositories/socle/BudgetRepository";
import {SocleClient} from "@/modules/Socle";

const components = {
    ThousandNumberInput,
};

interface MediaInfo {
    uuid: string;
    media: string;
    lever: string;
    rank: number;
}
@Component({components})
export default class CampaignLightLeversForm extends Vue {
    public bundle: Bundle | null = null;
    public loading: boolean = false;
    public budgets: Budget[] = [];
    public imgSrc: string = "";
    public budgetUuid: string = "";
    public selectedBudget: string | null = null;
    public budgetSelectReason: string = "";
    public commentSelectReason: string = "";
    public recommendedBudget: string | null = null;
    public lowerRecommendedBudget: number | null = null;
    public lastLog: BundleLog | null = null;
    public logMessageType: string | null = null;
    public bypassValidation: boolean = false;
    public leversAvailable: MediaInfo[] = [];

    @Prop(String) public bundleUuid!: string | null;
    @Prop(Boolean) public visible!: boolean;
    @Prop() public configSocleData!: SocleClient;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getCurrentUser") public currentUser!: User|null;

    @Watch("bundleUuid") private changeBundle() {
        this.fetchData();
    }

    @Watch("ownerUuid") private changeOwner() {
        this.fetchData();
    }

    public mounted() {
        if (!this.bundleUuid) {
            return;
        }
        this.fetchData();
    }

    private fetchData() {
        this.bypassValidation = false;
        return new Promise((resolve) => {
            if (!this.ownerUuid || !this.bundleUuid)  {
                return;
            }
            this.loading = true;
            const params = {
                filters: {
                    uuid: this.bundleUuid,
                },
                fields: [
                    "uuid",
                    "approvalStatus",
                    "approvedAt",
                    "noSelectedBudgetReason",
                    "campaign.uuid",
                    "campaign.label",
                    "campaign.startDate",
                    "campaign.endDate",
                    "campaign.code",
                    "campaign.externalCode",
                    "campaign.pictureBase64",
                    "campaign.formattedWeek",
                    "logs.performedBy.displayName",
                    "logs.loggedAt",
                    "logs.message",
                    "logs.metadata",
                    "hierarchyOwner.uuid",
                    "hierarchyOwner.fullName",
                    "hierarchyOwner.dependentStatus",
                    "hierarchyOwner.clientCode1",
                    "budgets.uuid",
                    "budgets.defaultBudget",
                    "budgets.label",
                    "budgets.selected",
                    "budgets.totalRecommendedAmount",
                    "budgets.validationDeadline",
                    "budgets.budgetLevers.budget",
                    "budgets.budgetLevers.comment",
                    "budgets.budgetLevers.support",
                    "budgets.budgetLevers.diffusion",
                    "budgets.budgetLevers.format",
                    "budgets.budgetLevers.lever.uuid",
                    "budgets.budgetLevers.lever.label",
                    "budgets.budgetLevers.lever.media.label",
                ]
            };
            BundleRepository.get(params)
                .then((data: object[]) => {
                    this.bundle = data[0] as Bundle;
                    this.imgSrc = this.bundle.campaign.pictureBase64;

                    if (this.bundle.logs) {
                        const first = _.first(this.bundle.logs);
                        this.lastLog = first !== undefined ? first as unknown as BundleLog : null;
                    }

                    const firstBudget = _.first(this.bundle.budgets);
                    if (firstBudget) {
                        this.lowerRecommendedBudget = _.get(firstBudget, "totalRecommendedAmount", 0);
                    }

                    const foundSelectedBudget = _.find(this.bundle.budgets, "selected");
                    if (foundSelectedBudget) {
                        this.selectedBudget = foundSelectedBudget.uuid;
                        this.recommendedBudget = _.invoke(
                            this.$options.filters,
                            "price",
                            foundSelectedBudget.totalRecommendedAmount
                        );
                    } else {
                        this.selectedBudget = null;
                    }
                    this.budgetSelectReason = this.bundle.noSelectedBudgetReason as unknown as string;
                    const retirementLog = _.find(this.bundle.logs, (log) => {
                        return log.metadata?.commentSelectReason;
                    });
                    this.commentSelectReason = _.get(retirementLog, "metadata.commentSelectReason" , "");

                    // Récupération des leviers disponibles sur les budgets du bundle sélectionné
                    this.leversAvailable = [];
                    _.forEach(this.bundle.budgets, (budget, idxBudget) => {
                        _.forEach(budget.budgetLevers, (lever, idxLever) => {
                            if (!_.find(this.leversAvailable, (line) => {
                                return line.media === lever.lever.media.label && line.lever === lever.lever.label;
                            } ) && lever.lever.uuid) {

                                const socleClientLever = _.find(this.configSocleData.levers, (clientLever) => {
                                    return clientLever.lever.uuid === lever.lever.uuid;
                                });

                                this.leversAvailable.push(
                                    {
                                        uuid: lever.lever.uuid,
                                        media: lever.lever.media.label,
                                        lever: lever.lever.label,
                                        rank: _.get(socleClientLever, "rank", 100),
                                    }
                                );
                            }
                        });
                    });
                    this.leversAvailable = _.sortBy(this.leversAvailable, (line) => {
                        return line.rank;
                    });

                    this.loading = false;
                    resolve(this.bundle);
                });
        });
    }

    public getBudgetFromLever(leverUuid: string, line: Budget): boolean|number {
        const budgetLever = _.find(line.budgetLevers, (lever) => {
            return lever.lever.uuid === leverUuid;
        });
        if (budgetLever) {
            return budgetLever.budget;
        }

        return false;
    }

    public getBudgetLeverComment(leverUuid: string, line: Budget): string {
        const budgetLever = _.find(line.budgetLevers, (lever) => {
            return lever.lever.uuid === leverUuid;
        });
        if (budgetLever) {
            const columns = ["support", "diffusion", "format"];
            const comment = columns.map((col) => _.get(budgetLever, col, "")).filter(Boolean).join(" - ");

            if (comment) {
                return comment;
            }
            return budgetLever.comment as unknown as string;
        }

        return "";
    }

    public validateBudget(): void {
        if (!confirm(_.invoke(this.$options.filters, "trans", "confirmValidationChoice"))) {
            return ;
        }

        const body = {
            selectedBudgetUuid: this.selectedBudget,
            noBudgetReason: "" !== this.budgetSelectReason ? this.budgetSelectReason : null,
            commentSelectReason: "" !== this.commentSelectReason ? this.commentSelectReason : null,
        };

        Http.callDirect(
            "/socle/" + this.bundleUuid + "/select",
            body,
            (data: any) => {
                this.$emit("update:visible", false);
                this.bundle = null;
                EventBus.$emit("budget-status-updated");
            },
            "error"
        );
    }

    public approveSelect(): void {
        if (!confirm(_.invoke(this.$options.filters, "trans", "confirmValidationChoice"))) {
            return ;
        }
        Http.callDirect(
            "/socle/" + this.bundleUuid + "/approve",
            {},
            (data: any) => {
                this.$emit("update:visible", false);
                this.bundle = null;
                EventBus.$emit("budget-status-updated");
            },
            "error"
        );
    }

    public rejectSelect(): void {
        this.$prompt("", "Commentaire", {
            confirmButtonText: _.invoke(this.$options.filters, "trans", "valid"),
            cancelButtonText: _.invoke(this.$options.filters, "trans", "cancel"),
        }).then((res) => {
            const value = (res as MessageBoxInputData).value;
            Http.callDirect(
                "/socle/" + this.bundleUuid + "/reject",
                {
                    rejectReason: value ? value : ""
                },
                (data: any) => {
                    this.$emit("update:visible", false);
                    this.bundle = null;
                    EventBus.$emit("budget-status-updated");
                },
                "error"
            );
        });
    }

    public cancelChoice(): void {
        const message = _.invoke(this.$options.filters, "trans", "confirmCancelChoice");
        if (confirm(message)) {
            this.bypassValidation = true;
        }
    }

    public editAllowed(): boolean {
        if (!this.bundle) {
            return false;
        }
        return (SOCLE_APPROVAL_STATUS_RECOMMENDED === this.bundle.approvalStatus  &&
            !this.isApprovalRequestPeriodPassed()) ||
            this.bypassValidation;
    }

    public isApprovalRequestPeriodPassed(): boolean {
        if (_.get(this.currentUser, "socleApprover", false) ||
            false === _.get(this.configSocleData, "approvalRequired", false)
        ) {
            return false;
        }

        const budgets = _.get(this.bundle, "budgets", []);
        const recommendedBudget = _.find(budgets, "defaultBudget");
        if (recommendedBudget) {
            const validationDl = moment(recommendedBudget.validationDeadline).set("hour", 23).set("minute", 59);
            const approvalRequestDl = validationDl.subtract(this.configSocleData.approvalDaysBeforeDeadline, "days");

            return approvalRequestDl < moment();
        }

        return true;
    }

    public isValidationDeadlinePassed(): boolean {
        const budgets = _.get(this.bundle, "budgets", []);
        const recommendedBudget = _.find(budgets, "defaultBudget");
        if (recommendedBudget) {
            const validationDl = moment(recommendedBudget.validationDeadline).set("hour", 23).set("minute", 59);
            return validationDl < moment();
        }

        return true;
    }

    public getValidationDeadline(): string {
        const budgets = _.get(this.bundle, "budgets", []);
        const recommendedBudget = _.find(budgets, "defaultBudget");
        if (recommendedBudget) {
            const validationDl = moment(recommendedBudget.validationDeadline).set("hour", 23).set("minute", 59);
            const approvalRequestDl = validationDl.subtract(this.configSocleData.approvalDaysBeforeDeadline, "days");

            return _.invoke(
                this.$options.filters,
                "trans",
                "approvalDeadlineMessage",
                "",
                "",
                {deadlineDate: approvalRequestDl.format("DD/MM/YYYY")}
            );
        }

        return "";
    }

    public getDeadlineMessage(): string {
        const budgets = _.get(this.bundle, "budgets", []);
        const recommendedBudget = _.find(budgets, "defaultBudget");
        if (recommendedBudget) {
            const validationDl = moment(recommendedBudget.validationDeadline).set("hour", 23).set("minute", 59);
            const approvalRequestDl = moment(recommendedBudget.validationDeadline).set("hour", 23).set("minute", 59)
                .subtract(this.configSocleData.approvalDaysBeforeDeadline, "days");

            let deadlineDate = approvalRequestDl.format("DD/MM/YYYY");
            let message = "approvalDeadlineInfo";
            if (_.get(this.currentUser, "socleApprover", false)) {
                deadlineDate = validationDl.format("DD/MM/YYYY");
                message = "validationDeadlineInfo";
            }

            return _.invoke(
                this.$options.filters,
                "trans",
                message,
                "",
                "",
                {deadlineDate}
            );
        }
        return "";
    }

    public isOperationValidated(): boolean {
        return SOCLE_APPROVAL_STATUS_APPROVED === _.get(this.bundle, "approvalStatus", "");
    }

    public getLogDate(date: Date): string {
        return _.invoke(
            this.$options.filters,
            "date",
            date
        );
    }

    public getLogMessage(): string {
        if (!this.lastLog) {
            return "";
        }

        this.logMessageType = this.lastLog.message as string;
        const dateLog = _.invoke(this.$options.filters, "date", this.lastLog ? this.lastLog.loggedAt : new Date());
        const author = this.lastLog.performedBy ? this.lastLog.performedBy.displayName : "défaut";

        switch (this.logMessageType) {
            case "approval_request":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "approval_request_message",
                    "",
                    "",
                    { dateLog, performer: author }
                );
            case "cancel":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "cancel",
                    "",
                    "",
                    { dateLog, performer: author }
                );
            case "default_confirm_automated":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "default_confirm_automated_message",
                    "",
                    "",
                    { dateLog }
                );
            case "default_confirm":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "default_confirm_message",
                    "",
                    "",
                    { dateLog, performer: author }
                );
            case "approve":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "default_confirm_message",
                    "",
                    "",
                    { dateLog, performer: author }
                );
            case "reject":
                let rejectReason = "";
                if (_.get(this.lastLog, "metadata.rejectReason", false)) {
                    rejectReason = " \"" + _.get(this.lastLog, "metadata.rejectReason", false) + " \"";
                }
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "reject_message",
                    "",
                    "",
                    { dateLog, performer: author }
                ) + rejectReason;
            default:
                return "";
        }
    }

    public closed() {
        this.$emit("closed");
    }
}
